import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { arrayIsDefinedAndContainsKey } from '../shared/array-functions';
import { getCurrentDateForAPI } from '../shared/date-functions';
import { CONSTANTS } from '../shared/constants';

@Injectable()
export class HelpService {
  private apiUrl: string;
  listOfComplaints: object [];
  reasons: object[];
  
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.api.protocol + environment.api.hostname + environment.api.path;
  }

  /*
   * Retrieve last submitted complaint for each subscription (last 3 days)
   * API endpoint: GetLastIssueComplaint?GigyaUserID=gigyaUserId
  */
  getLastSubmittedComplaint(gigyaId) {
    const route = 'GetLastIssueComplaint';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.gigyaIdQueryParam + '=' + gigyaId).subscribe(
      (data) => {
        if (arrayIsDefinedAndContainsKey(data, 'CMS_SAM_Get_LastIssueComplaint_ByCustomerID')) {
          this.listOfComplaints = data['CMS_SAM_Get_LastIssueComplaint_ByCustomerID'];
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
      });
  }

  /*
   * Get list of possible complaint reasons
   * API endpoint: IssueComplaintsResolutionsDescriptions
  */
  getComplaintReasons() {
    const route = 'IssueComplaintsResolutionsDescriptions';
    return this.http.get(this.apiUrl + route).subscribe(
      (data) => {
        if (arrayIsDefinedAndContainsKey(data, 'CMS_SAM_Get_IssueComplaintsResolutionsDesc')) {
          this.reasons = data['CMS_SAM_Get_IssueComplaintsResolutionsDesc'];
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
      });
  }

  /*
    * Create new complaint
    * API endpoint: /AddIssueComplaint
    * Request Payload: SubID, PubDate, ReasonID, OriginCall, Comments
  */
  addNewComplaint(subscriptionId, reasonId, gigyaId): Observable<any> {
    const route = 'AddIssueComplaint';
    const payload = {
      SubID: subscriptionId,
      PubDate: getCurrentDateForAPI(),
      ReasonID: reasonId,
      OriginCall: 'SAM',
      Comments: 'Complaint by micuenta.elnuevodia.com'
    };  
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {
      this.getLastSubmittedComplaint(gigyaId); 
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Submit contact form
    * API endpoint: /ContactFormSubmit
    * Request Payload: Name, Email, Subject, Product, Message
  */
  submitContactForm(contactForm): Observable<any> {
    const route = 'ContactFormSubmit';
    const payload = {
      Name: contactForm.name,
      Email: contactForm.email,
      Subject: contactForm.subject,
      Product: contactForm.product,
      Message: contactForm.message,
      Phone: contactForm.phoneNumber
    };  
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Get subscriptions of a customer and filter to return only print subscriptions
    * API endpoint: SubscriptionInfo?GigyaUserID=gigyaUserId
  */
  getPrintSubscriptions(gigyaUserId): Observable<any> {
    const route = 'SubscriptionInfo';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.gigyaIdQueryParam + '=' + gigyaUserId)
    .map((res: Response) => {
      let printSubscriptions;
      if(arrayIsDefinedAndContainsKey(res, 'CMS_SAM_SubscriptionInfo_ByGigyaID')) {
        printSubscriptions = res['CMS_SAM_SubscriptionInfo_ByGigyaID'].filter((subscription) => { return subscription.NoPrintSubscription === 0 }); // If false, it means that it has print subscription
      }
      return printSubscriptions; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  private handleError(err: HttpErrorResponse) {
    if (err.error instanceof Error) {
      // A client-side or network error occurred
      console.log('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code
      console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/help.service.ts